module.exports = __webpack_public_path__ + "static/potfolio-banner-hero-one-9d5d5dcee8d6f4bfd92e946c81fc8874.png";